import { useEffect, useRef, useState, useCallback } from 'react';
import { APIService } from '../services/api';

// A single read is shared by the results notice and the snapshot view.
export default function useDiagnosticHistory(origin) {
  const request = useRef(null);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ origin: null, status: 'idle', response: null });
  const retry = useCallback(() => {
    request.current = null;
    setAttempt(value => value + 1);
  }, []);

  useEffect(() => {
    let disposed = false;
    if (!origin) {
      request.current = null;
      setState({ origin: null, status: 'idle', response: null });
      return;
    }
    setState({ origin, status: 'loading', response: null });
    if (request.current?.origin !== origin) {
      request.current = { origin, promise: APIService.getSnapshotHistory(origin, 90) };
    }
    request.current.promise.then(response => {
      if (!response?.success) throw new Error('Snapshot history unavailable');
      if (!disposed) setState({ origin, status: 'ready', response });
    }).catch(() => {
      if (!disposed) setState({ origin, status: 'error', response: null });
    });
    return () => { disposed = true; };
  }, [origin, attempt]);

  return {
    ...(state.origin === origin ? state : { origin, status: origin ? 'loading' : 'idle', response: null }),
    retry
  };
}
